import { metadataItemsActions } from './metadataItems.actions';
import { userActions } from './user.actions';

export function bootstrapAppData() {
  return async (dispatch) => {
    const results = await Promise.allSettled([
      dispatch(userActions.getInfo()),
      dispatch(metadataItemsActions.fetchAll()),
    ]);

    const firstRejected = results.find((result) => result.status === 'rejected');
    if (firstRejected) {
      throw firstRejected.reason;
    }

    return results;
  };
}
